import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { Subject } from 'rxjs'
import { KeySystemStatuses } from '../../../constants/keySystem-statuses'
import { KeySystem, Structure } from '../../../models/dev.test.models'
import { KeySystemDataSets } from '../../../services/keying.data.sets.service'
import { KeyingSystemService } from '../../../services/keying.system.service'

@Component({
    selector: 'app-system-top-bar',
    templateUrl: './system-top-bar.component.html',
    styleUrls: ['./system-top-bar.component.scss'],
    standalone: false
})
export class SystemTopBarComponent implements OnInit, OnDestroy {
  destroy$ = new Subject()
  @Input() structure: Structure
  @Input() keySystem: KeySystem
  @Input() keySystemDataSets: KeySystemDataSets
  @Input() keywayFamily
  @Input() combinatingRule

  keySystemStatus: string = ''

  constructor(private keyingSystemService: KeyingSystemService) {}

  /* istanbul ignore next */
  ngOnInit(): void {
    this.getKeySystemStatus()
  }

  /* istanbul ignore next */
  ngOnDestroy() {
    this.destroy$.next(true)
    this.destroy$.complete()
  }

  /* istanbul ignore next */
  private getKeySystemStatus(): void {
    this.keyingSystemService.keySystem$.subscribe((keySystem) => {
      const statusId = keySystem?.statusId
      if (statusId) {
        Object.keys(KeySystemStatuses).forEach((x) => {
          if (x == statusId.toString()) {
            this.keySystemStatus = KeySystemStatuses[x]
          }
        })
      }
    })
  }
}
